import Config from 'src/core/utils/Config';
import Constants from 'src/core/utils/Constants';
import LoggingService from 'src/data/services/LoggingService';
import SentryService from 'src/data/services/SentryService';

const TAG = '[logError]';

/**
 * Central handler for fire-and-forget errors (e.g.
 */
export default function logError(error: unknown): void {
	const message = error instanceof Error ? error.message : String(error);
	LoggingService.error(TAG, message, error);

	if (Config.environment !== Constants.sentryEnvironmentDevelopment) {
		SentryService.captureException(error);
	}
}
